import { generateContext } from '@/context/utils';
import reducer from '@/account/context/wishlist/reducer';
import initialState from '@/account/context/wishlist/state';
import actions from '@/account/context/wishlist/actions';

const { WishlistProvider, useWishlistContext } = generateContext(
  'WishlistProvider',
  'useWishlistContext',
  initialState,
  reducer,
  actions,
);

export { WishlistProvider, useWishlistContext };
